
import { defineComponent } from '@vue/composition-api'
import { declination } from '@artmizu/utils'
import RowSliderNew from '~/components/sliders/RowSliderNew/RowSliderNew.vue'
import ErrorSerializer from '~/serializer/Error'
import getOpenGraphMarkup from '~/helper/getOpenGraphMarkup'
import TSProductPromo from '~/components/ts-components/TSProductPromo/TSProductPromo.vue'
import CategoriesGrid from '~/components/CategoriesGrid/CategoriesGrid.vue'
import CategorySidebar from '~/components/CategorySidebar/CategorySidebar.vue'
import CatalogWideBanner from '~/components/CatalogWideBanner/CatalogWideBanner.vue'
import ViewportToogle from '~/components/ViewportToogle/ViewportToogle.vue'
import BrandEl from '~/components/Brands/BrandEl/BrandEl.vue'
import TSProductCard from '~/components/ts-components/TSProductCard/TSProductCard.vue'
import type Constructor from '~/api/constructor.api'

type RequestType = Awaited<ReturnType<typeof Constructor.category>>['result']

export default defineComponent({
  components: {
    RowSliderNew,
    TSProductPromo,
    CategoriesGrid,
    CategorySidebar,
    CatalogWideBanner,
    ViewportToogle,
    BrandEl,
    TSProductCard,
  },
  inject: ['emitter'],
  async asyncData({ app, route, $pageError }) {
    try {
      const response = (
        await app.$api.constructor.category({
          seo: route.path,
        })
      )?.result
      return {
        response,
        count: response?.count || 0,
      }
    }
    catch (e) {
      const error = ErrorSerializer(e)
      new $pageError({
        ...error,
        message: error.code === 404 ? 'Категории каталога не найдены' : error.message,
      })
    }
  },
  data(): { response?: RequestType ; count: number } {
    return {
      response: undefined,
      count: 0,
    }
  },
  head(): { [key: string]: unknown } {
    return {
      title: this.response?.meta?.category?.title,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.response?.meta?.category?.description,
        },
        ...getOpenGraphMarkup({
          type: 'product.group',
          url: this.$nuxt.context.env.projectURL + this.$route.fullPath,
          image: this.response?.thumbnail?.x2 || this.$nuxt.context.env.projectURL + require('~/assets/images/05-avatar.png'),
          title: this.response?.meta?.category?.title,
          description: this.response?.meta?.category?.description,
        }),
      ],
    }
  },
  computed: {
    declOfNumGoods() {
      return `${this.count} ${declination(this.count, ['модель', 'модели', 'моделей'])}`
    },
  },
  mounted() {
    if (this.response) {
      this.$emitter.emit('view-category', {
        id: this.response.id,
        name: this.response.name,
      })
    }
  },
  methods: {
    getCountProduct(index: number) {
      if (this.response && this.response?.sliders?.length)
        return this.response.sliders.length === index ? 9 : 6
    },
    removeFavorite(e: string) {
      this.$emitter.emit('remove-from-favorite', { id: e })
    },
    bannerSelect() {
      if (this.response?.banner)
        this.$emitter.emit('banner-select', { banner: this.response.banner })
    },
  },
})
